import { render, staticRenderFns } from "./BLMatch.vue?vue&type=template&id=71573446&"
import script from "./BLMatch.vue?vue&type=script&lang=js&"
export * from "./BLMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports